'use client'

// A domain / entity-reference value in a table cell: the text, cut to the
// column with the full value on hover, "+N" when the entry has more than
// this one, "—" when it has none.
export function ValueCell({ value, extra = 0, mono = false, isDark }: { value?: string | null; extra?: number; mono?: boolean; isDark: boolean }) {
  if (!value) return <span className={'text-subtle'}>—</span>
  return (
    <span className="flex min-w-0 items-center gap-1" title={value}>
      <span className={`truncate ${mono ? 'font-mono' : ''} text-muted-foreground`}>{value}</span>
      {extra > 0 && <span className={`shrink-0 font-mono text-[10px] text-subtle`}>+{extra}</span>}
    </span>
  )
}
